import { memo, useMemo } from "react";
import Grid from "components/primitives/Grid";
import Tables from "components/Tables";
import AthleteTableControlSort from "../AthleteTableControlSort";
import Divider from "@mui/material/Divider";
import AthleteTableControlsBulk1rmEdit from "../AthleteTableControlsBulk1rmEdit";
import useSelectedEntities from "providers/SelectedEntitiesProvider/useSelectedEntities";
import IconPopperMenu from "components/IconPopperMenu";
import AthleteTableBulkGroupAssign from "../AthleteTableBulkGroupAssign";
import CanDoAction from "components/CanDoAction/CanDoAction";
import useGroups from "providers/GroupsProvider/useGroups";
import useRole from "providers/RoleProvider/useRole";
import { Group } from "types/groups";
import { useTranslation } from "react-i18next";
import AthleteTableBulkActions from "./AthleteTableBulkActions";

const defaultProps = {
  config: {
    showDeleteAthleteAction: true,
  },
};

interface AthleteTableIconButtonControlsProps {
  config?: {
    showDeleteAthleteAction?: boolean;
  };
}

function AthleteTableIconButtonControls(props: AthleteTableIconButtonControlsProps) {
  const tableProps = { ...defaultProps, ...props };
  const config = { ...defaultProps.config, ...tableProps.config };

  const selectedGroups = useSelectedEntities<Group>();
  const groups = useGroups();
  const role = useRole();
  const { t } = useTranslation();

  const showBulkGroupAssignForCoach = useMemo(() => !Boolean(role === "COACH" && groups.length <= 1), [role, groups]);

  const PopperContent = useMemo(
    () => (
      <Tables.Components.TableFiltersPopperContent
        SearchInputProps={{ placeholder: t("athlete.table_group_filter_tooltip_title") }}
        options={groups}
        getOptionLabel={(option) => option.name}
        getColor={(option) => option.colour}
      />
    ),
    [t, groups]
  );

  return (
    <Grid
      container
      height="100%"
      alignItems="center"
      sx={{
        width: "100%",
      }}
    >
      <CanDoAction action="group.view">
        <Grid {...Tables.controlCells.standard}>
          <IconPopperMenu
            tooltipTitle={t("athlete.table_group_filter_tooltip_title")}
            icon={<Tables.Icons.Filter />}
            badgeContent={selectedGroups.length}
            popperContent={PopperContent}
          />
        </Grid>
      </CanDoAction>
      <Grid {...Tables.controlCells.standard}>
        <AthleteTableControlSort />
      </Grid>
      <Grid width={"1px"} height="calc(100% - 30px)">
        <Divider orientation="vertical" />
      </Grid>
      <CanDoAction action="group.any">
        {showBulkGroupAssignForCoach && (
          <Grid {...Tables.controlCells.standard}>
            <AthleteTableBulkGroupAssign />
          </Grid>
        )}
      </CanDoAction>
      <Grid {...Tables.controlCells.standard}>
        <AthleteTableControlsBulk1rmEdit />
      </Grid>
      <Grid width={"1px"} height="calc(100% - 30px)">
        <Divider orientation="vertical" />
      </Grid>
      <AthleteTableBulkActions config={config} />
    </Grid>
  );
}

export default memo(AthleteTableIconButtonControls);
